import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import deletePrimaryIcon from '../../asset/img/delete_primary.svg';

import Typography from '../../components/common/Typography';

import Chips from '../../components/common/Chips';
import { IconButton } from '../../components/common/Button';
import { setSelectedPreviousEmployment } from './previousSlice';
import {
  formatDate,
  getAlertMessageFunction,
  getDeleteDialogConfig,
  magamCertifyCheck,
} from '../../common/Util';
import EmptyListSectionItem from './EmptyListSectionItem';
import EmptyListMessage from './EmptyListMessage';

const PreviousEmploymentList = ({ onItemClick }) => {
  const { t } = useTranslation('previousEmployment');
  const { t: tCommon } = useTranslation('common');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const alertMessage = getAlertMessageFunction();
  const { dataList, isRender, reload } = useSelector(state => state.previousEmployment);
  const { isMagam, isCertify } = useSelector(state => state.common);

  const handleClick = (htmSeq, htmJType) => {
    console.log('handleClick', htmSeq, htmJType);
    onItemClick(htmSeq, htmJType);
  };

  const handleDelete = (htmSeq, isNotDelete) => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    if (isNotDelete) {
      alertMessage('관리자에 의해 등록된 전직장입니다. 삭제하실 수 없습니다.');
      return;
    }

    const deleteConfig = getDeleteDialogConfig(tCommon, 'previousEmployment', {
      htmSeq: htmSeq,
    });
    dispatch(deleteConfig);
  };

  return (
    <div className="listSection">
      <Typography variant="subtitleBold">{t('listSection.title')}</Typography>
      <div className="listSectionItemBox" style={{ justifyContent: 'flex-start' }}>
        {dataList.length === 0 ? (
          <EmptyListMessage />
        ) : (
          dataList.map((item, index) => (
            <ListSectionItem
              key={index}
              item={item}
              onClick={handleClick}
              onDelete={handleDelete}
              isNotDelete={item.htmFlag !== null || item.htm024 !== null}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default PreviousEmploymentList;

const ListSectionItem = ({ item, onClick, onDelete, isNotDelete }) => {
  //htmFlag :
  //htmJType : 1 전직장, 2 납세조합
  //htm019~htm020 : 전직장 날짜
  const { htmSeq, htmJType, htm002, htm019, htm020 } = item;

  return (
    <div className="listSectionItem" onClick={() => onClick(htmSeq, htmJType)}>
      <div className="displayFlexColumn" style={{ gap: '8px' }}>
        <Chips color="primary">{htmJType === '1' ? '전직장' : '납세조합'}</Chips>
        <div className="displayFlexColumn" style={{ gap: '2px' }}>
          <Typography variant="body2Bold">{htm002}</Typography>
          <Typography variant="body2Medium">
            {formatDate(htm019)} ~ {formatDate(htm020)}
          </Typography>
        </div>
      </div>
      <IconButton
        imgSrc={deletePrimaryIcon}
        variant="contained"
        color="primaryLight"
        size="medium"
        onClick={e => {
          e.stopPropagation();
          onDelete(htmSeq, isNotDelete);
        }}
      />
    </div>
  );
};
